module.exports = __webpack_public_path__ + "static/media/undraw_experience.37c3d1cc.svg";